import { Pipe, PipeTransform } from '@angular/core';
import { PASSWORD_VIEW } from '@frontend-site/shared/data';

@Pipe({
    name: 'pKeyValueSensitiveConvertor'
})
export class PKeyValueSensitiveConvertor implements PipeTransform {
    transform(values: Record<string, unknown>): Record<string, unknown> {
        const aggregatedValues: Record<string, unknown> = {};
        Object.keys(values).forEach((key) => {
            const value = values[key] as any;
            if (value instanceof Object) {
                aggregatedValues[key] = value['isSensitive'] ? PASSWORD_VIEW : value['value'];
            } else {
                aggregatedValues[key] = value;
            }
        });
        return aggregatedValues;
    }
}
